import {React, useCallback, useContext, useState} from 'external/react'
import Modal from 'react-modal'
import Text from 'react-text'
import {Context} from '../../context'
import fetch from 'helpers/command'
import StandardsSelector from 'components/standards-selector/components/StandardsSelector'
import {updatePlanStandards} from 'components/standards-selector/domain/planning-summary.cjs'
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import './index.styl'

export default function AddStandard () {
  const context = useContext(Context)
  const {newPlan, languageId, query, setState} = context
  const [isOpen, setIsOpen] = useState(true)
  const [filters, setFilters] = useState(query || {})
  const selected = (newPlan.content || {}).standards || []
  const load = useCallback((entity, parameters) => fetch('de', entity)({language: languageId, ...parameters}), [languageId])

  function navigateOut () {
    context.navigate({}, context.match.path.replace(/\/:section.*$/,''), {query: {template:query.template}})
  }

  function changeSelection(standards) {
    setState({newPlan:updatePlanStandards(newPlan, standards)})
  }

  return <Modal
    isOpen={isOpen}
    onAfterClose={navigateOut}
    onRequestClose={() => setIsOpen(false)}
    contentLabel=""
    className="add-standard-wrapper"
    appElement={document.querySelector('#root')}
    closeTimeoutMS={800}>
    <div className="add-standard">
      <div className="title">
        <div className="label">
          <Text id="standards" />
          {newPlan.title != '' && `: ${newPlan.title}`}
        </div>
        <div className="close" onClick={() => setIsOpen(false)}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </div>
      </div>
      <div className="content">
        <div className="selector-content">
          <StandardsSelector language={languageId} load={load} mode="planning"
            filters={filters} onFiltersChange={setFilters}
            selected={selected} onSelectionChange={changeSelection}/>
        </div>
        <div className="buttons" style={{display:'flex'}}>
          <div style={{flexGrow:1}} />
          <button className="accept" onClick={() => setIsOpen(false)}><Text id="accept" /></button>
        </div>
      </div>
    </div>
  </Modal>
}
